<template>
  <basic-container>
    <!-- v-if="!loading" -->
    <avue-crud
    v-if ="showCrud"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @expand-change="expandChange"
      @on-load="onLoad"
    >
      <template slot-scope="{ row }" slot="type">
        <el-tag
          style="font-size: 14px; width: 76px; height: 32px; line-height: 32px; text-align: center;"
          :type="row.type === 0 ? 'success' : 'danger'"
        >
          {{ row.type === 0 ? '放假' : '补班' }}</el-tag
        >
      </template>

      <template slot="menuLeft" slot-scope="scope" >
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addFormData()">新增</el-button>
      </template>
    </avue-crud>
    <el-dialog title="新增"
        :visible.sync="dialogAddFormVisible"
        v-if="dialogAddFormVisible"
        append-to-body>
        <avue-form :option="addFormOption" @submit="handleSubmit"></avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, submitFormData, getTableStructure } from '@/api/holiday/holiday';
import { mapGetters } from 'vuex';
import { getFormTemplateByProjectId } from '@/api/form'
export default {
  data() {
    return {
      showCrud:false,
      publicColumn:[],
      extendColumn:[],
      mainColumn:[],
      addFormOption:{
        column:[],
      },
      dialogAddFormVisible:false,
      formTemplateData:{},
      noticTypeTempData: [],
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        addBtn: false,
        enter: false,
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexWidth: 60,
        indexLabel: '序号',
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        columnBtn: false,
        dialogWidth: '40%',
        align: 'center',
        column: [
          {
            label: '日期类型',
            prop: 'type',
            type: 'select',
            dataType: 'number',
            search: true,
            span: 22,
            slot: true,
            dicData: [
              {
                label: '补班',
                value: 1,
              },
              {
                label: '放假',
                value: 0,
              },
            ],
            rules: [
              {
                required: true,
                message: '请选择日期类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '节日说明',
            prop: 'remark',
            maxlength: 100,
            span: 22,
            search: true,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入节日说明',
                trigger: 'change',
              },
            ],
          },
          {
            label: '节日月份',
            prop: 'dateSearch',
            type: 'month',
            hide: true,
            display: false,
            searchRange: false,
            search: true,
            span: 22,
            format: 'yyyy-MM',
            valueFormat: 'yyyy-MM',
          },
          {
            label: '日期',
            prop: 'date',
            type: 'date',
            span: 22,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '创建时间',
            display: false,
            span: 22,
            prop: 'createTime',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
        ],
      },
      tempMainTableTemplateColumn:'',
      data: [],
    };
  },
  created(){
      this.getOption();
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.holiday_add, false),
        viewBtn: this.vaildData(this.permission.holiday_view, false),
        delBtn: this.vaildData(this.permission.holiday_delete, false),
        editBtn: this.vaildData(this.permission.holiday_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  watch: {},
  methods: {
    async getOption(){
      this.tempMainTableTemplateColumn = this.option.column;
          await getTableStructure({projectId:'1231131'}).then((res)=>{
            console.log(res.data);
            this.$nextTick(()=>{
              this.option.column = res.data['/holiday/holiday'];
              this.showCrud = true;
            });
          });
    },
    toTableDesign(){
      this.$router.push(
        `/table-extension/table-extension-design?pageUrl=${encodeURI('/holiday/holiday')}`
      )
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    isContainKeyWords(text){
      var str = ("abstract,assert,boolean,break,byte,case,catch,char,class,continue,default,do,double,else,enum,extends,final,finally,float,for,if,implements,import,int,interface,instanceof,long,native,new,package,private,protected,public,return,short,static,strictfp,super,switch,synchronized,this,throw,throws,transient,try,void,volatile,while,ADD,ANALYZE,ASC,BETWEEN,BLOB,CALL,CHANGE,CHECK,CONDITION,CONTINUE,CROSS,CURRENT_TIMESTAMP,DATABASE,DAY_MICROSECOND,DEC,DEFAULT,DESC,DISTINCT,DOUBLE,EACH,ENCLOSED,EXIT,FETCH,FLOAT8,FOREIGN,GOTO,HAVING,HOUR_MINUTE,IGNORE,INFILE,INSENSITIVE,INT1,INT4,INTERVAL,ITERATE,KEYS,LEADING,LIKE,LINES,LOCALTIMESTAMP,LONGBLOB,LOW_PRIORITY,MEDIUMINT,MINUTE_MICROSECOND,MODIFIES,NO_WRITE_TO_BINLOG,ON,OPTIONALLY,OUT,PRECISION,PURGE,READ,REFERENCES,RENAME,REQUIRE,REVOKE,SCHEMA,SELECT,SET,SPATIAL,SQLEXCEPTION,SQL_BIG_RESULT,SSL,TABLE,TINYBLOB,TO,TRUE,UNIQUE,UPDATE,USING,UTC_TIMESTAMP,VARCHAR,WHEN,WITH,XOR").toLowerCase();
      
      let text_ = text+'';
      // console.log(str,text_);
      let strs = [];
      let isContainFlag = false;
      strs=str.split(",");
      strs.forEach(element => {
        // console.log(text_.indexOf(element));
        if (text_.indexOf(element) >= 0) {
            // alert(`字符串中包含(${element})字符串`);
            isContainFlag = true;
            // console.log('包含关键字！！！！！');
        } else {
            // alert(`字符串中 不包含(${element})字符串`);
        }
      });
      return isContainFlag;
    },
    rowUpdate(row, index, done, loading) {
      let isContain = false;
      let isHasKeywords = false;
      for(var key in row){
        isContain = this.isContainKeyWords(row[key]);
        if(isContain){
          isHasKeywords = true;
        }
      }
      if(isHasKeywords){
        this.$message.error('输入内容不得包含关键字！');
        done();
        return;
      }
      this.editFormData();
      console.log(row);
      // let obj = {a:666,b:888}
      //  console.log(form);
       row.deptId = '1123598813738675201';
       row.pageUrl = '/holiday/holiday';
       row.mainFields = {};
       row.publicFields = {};
       row.extendFields = {};
       if(this.publicColumn.length>0){
         
        this.publicColumn.forEach((e)=>{
          row.publicFields[e.prop] = row[e.prop];
        });
       }
       if(this.mainColumn.length>0){
         
        this.mainColumn.forEach((e)=>{
          row.mainFields[e.prop] = row[e.prop];
        });
       }
       if(this.extendColumn.length>0){
         
        this.extendColumn.forEach((e)=>{
          row.extendFields[e.prop] = row[e.prop];
        });
       }
       row.mainFields['id'] = row.id;
       console.log(row);
      //  return;
      let form_ = {
        fields:{

          extendFields:row.extendFields,
          
          publicFields:row.publicFields,
          mainFields:row.mainFields,
        },
        id:row.id,
        pageUrl:row.pageUrl,
        deptId:row.deptId
      };
       console.log(form_);
      // return;
      submitFormData(form_).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    
    editFormData(){
      let columnList = [];
      let self = this;
      // let publicColumn = [];
      // let extendColumn = [];
      // let mainColumn = [];
console.log(self.formTemplateData);
      if(self.formTemplateData.publicFormInfo.createJson){
        self.publicColumn = self.formTemplateData.publicFormInfo.createJson.fields
      }
      if(self.formTemplateData.mainFormInfo.createJson){
        // self.mainColumn = self.formTemplateData.mainFormInfo.createJson.column
        self.mainColumn = self.tempMainTableTemplateColumn;
      }
      if(self.formTemplateData.extendFormInfo.createJson){
        self.extendColumn = self.formTemplateData.extendFormInfo.createJson.fields
      }
      console.log(self.publicColumn,self.extendColumn,self.mainColumn);
      columnList = columnList.concat(self.mainColumn);
      columnList = columnList.concat(self.publicColumn);
      columnList = columnList.concat(self.extendColumn);
      
      console.log(columnList);

      self.addFormOption.column = columnList;

    },
    addFormData(){
      let columnList = [];
      let self = this;
console.log(self.formTemplateData);
      if(self.formTemplateData.publicFormInfo.createJson){
        self.publicColumn = self.formTemplateData.publicFormInfo.createJson.fields
      }
      if(self.formTemplateData.mainFormInfo.createJson){
        self.mainColumn = self.formTemplateData.mainFormInfo.createJson.column
      }
      if(self.formTemplateData.extendFormInfo.createJson){
        self.extendColumn = self.formTemplateData.extendFormInfo.createJson.fields
      }
      console.log(self.publicColumn,self.extendColumn,self.mainColumn);
      columnList = columnList.concat(self.mainColumn);
      columnList = columnList.concat(self.publicColumn);
      columnList = columnList.concat(self.extendColumn);
      console.log(columnList);

      self.addFormOption.column = columnList;
      self.dialogAddFormVisible = true;
    },
    handleSubmit(form,done){
       console.log(form);
       form.deptId = '1123598813738675201';
       form.pageUrl = '/holiday/holiday';
       form.mainFields = {};
       form.publicFields = {};
       form.extendFields = {};
       if(this.publicColumn.length>0){
         
        this.publicColumn.forEach((e)=>{
          form.publicFields[e.prop] = form[e.prop];
        });
       }
       if(this.mainColumn.length>0){
         
        this.mainColumn.forEach((e)=>{
          form.mainFields[e.prop] = form[e.prop];
        });
       }
       if(this.extendColumn.length>0){
         
        this.extendColumn.forEach((e)=>{
          form.extendFields[e.prop] = form[e.prop];
        });
       }
       console.log(form);
      //  return;
      let form_ = {
        fields:{

          extendFields:form.extendFields,
          
          publicFields:form.publicFields,
          mainFields:form.mainFields,
        },
        pageUrl:form.pageUrl,
        deptId:form.deptId
      };
       submitFormData(form_).then((res)=>{
         console.log(res);
          this.onLoad();
          this.$message.success('操作成功!');
          this.dialogAddFormVisible = false;
          done();
       })
          // done();
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getFormTemplateByProjectId('1123598813738675201','2','/holiday/holiday').then((res)=>{
        this.formTemplateData = res.data.data;
        console.log(res.data.data);
      });
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          console.log(data.records);
          console.log(data.records);
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style></style>
